import { AxiosError } from "axios";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useAskQuestionFromImageIntell = () => {
  return useMutation<
    { id: string },
    AxiosError<any>,
    {
      executionId: string;
      prompt: string;
    }
  >(
    ({ executionId, prompt }) => {
      return axiosClient
        .post(
          `/image-intell/qna`,
          {
            executionId,
            prompt,
          },
          {
            timeout: 5 * 60 * 1000, // min
          }
        )
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
